export const GET_FEE_LIST = 'FEE/get_fee';
export const GET_SINGLE_FEE = 'FEE/get_single_fee';
export const UPDATE_FEE = 'FEE/update_fee';
export const CREATE_FEE = 'FEE/create_fee';
export const REMOVE_FEE = 'FEE/remove_fee';

export const GET_REQUIREMENT_ITEM = 'REQUIREMENT/GET_REQUIREMENT_ITEM';
export const GET_REQUIREMENT_LIST = 'REQUIREMENT/GET_REQUIREMENT_LIST';
export const GET_PERMIT_TYPE_LIST = 'REQUIREMENT/GET_PERMIT_TYPE_LIST';
export const UPDATE_APPLICATION_REQUIREMENT =
  'REQUIREMENT/UPDATE_APPLICATION_REQUIREMENT';

export const GET_PURPOSE_LIST = 'BIRTH_CERTIFICATE/get_purpose_list';

export const MODULE_TYPE = [
  {label: 'ALL', value: ''},
  {label: 'BIRTH CERTIFICATE', value: 'BIRTH CERTIFICATE'},
  {label: 'DEATH CERTIFICATE', value: 'DEATH CERTIFICATE'},
  {label: 'MARRIAGE CERTIFICATE', value: 'MARRIAGE CERTIFICATE'},
];

export const FEE_TYPE = [
  {label: 'BASE PRINT FEE', value: 'BASE_PRINT_FEE'},
  {label: 'FIXED RATE FEE', value: 'FIXED_RATE_FEE'},
  {label: 'PER COPY FEE', value: 'PER_COPY_FEE'},
];

export const FEE_TYPE_FILTER = [
  {label: 'ALL', value: ''},
  {label: 'BASE PRINT FEE', value: 'BASE_PRINT_FEE'},
  {label: 'FIXED RATE FEE', value: 'FIXED_RATE_FEE'},
  {label: 'PER COPY FEE', value: 'PER_COPY_FEE'},
];